import apiConfig from '../constants/apiConfig';
import axios from 'axios';
import {
  selectGroupGuid,
  selectUserGuid,
  useAppSelector,
} from '../slices/commonSelectors';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ResourceSet, keys } from '@/components/IAP/hooks/resourceSetHooks';

export const useImportAlmisDataFromFile = () => {
  const queryClient = useQueryClient();
  const groupId = useAppSelector(selectGroupGuid);
  const userId = useAppSelector(selectUserGuid);
  return useMutation({
    mutationFn: async (file: File) => {
      if (!groupId) {
        throw new Error('groupId is required to create new ALMIS data');
      }

      const formData = new FormData();
      formData.append('almis_file', file);
      return await axios.post<ResourceSet[]>(
        apiConfig.apiGateway.importAlmisDataFromFile(groupId),
        formData
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: keys.list(groupId, userId),
      });
    },
  });
};
